export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/rental/index/resources/computed.js